<div class="containerList">
  <p class="my-3" *ngIf="!compromisosList.length">
    No se encontraron compromisos
  </p>
  <ul *ngIf="compromisosList.length" class="commitments-list">
    <li class="commitment-header">
      <h3>Titulo</h3>
      <h3>Aplica a</h3>
      <h3>Dimensiones</h3>
      <h3>ODS</h3>
    </li>

    <ul
      class="commitment-item"
      *ngFor="let compromiso of compromisosList; let i = index"
    >
      <li
        routerLink="/compromisos/{{ compromiso.code }}/detalle"
        [state]="{ comingFrom: 'communities' }"
      >
        <h4>{{ compromiso.title }}</h4>
        <div class="appliesTo">
          <app-svg-icon
            [iconType]="'person'"
            [color]="compromiso.appliesToPersons ? 'currentColor' : '#cfcfcf'"
            matTooltip="Personas"
          ></app-svg-icon>
          <app-svg-icon
            [iconType]="'company'"
            [color]="compromiso.appliesToCompanies ? 'currentColor' : '#cfcfcf'"
            matTooltip="Empresas"
          ></app-svg-icon>
          <app-svg-icon
            [iconType]="'service'"
            [color]="compromiso.appliesToServices ? 'currentColor' : '#cfcfcf'"
            matTooltip="Aplicaciones"
          ></app-svg-icon>
        </div>
        <app-ods-display
          [sustainableDevelopmentGoals]="compromiso.sustainableDevelopmentGoals"
          [commitmentCode]="compromiso.code"
        ></app-ods-display>
        <div class="dimensiones">
          <app-svg-icon
            [iconType]="'ambiente'"
            [color]="compromiso.dimensionE ? 'currentColor' : '#cfcfcf'"
            matTooltip="Ambiente"
          ></app-svg-icon>
          <app-svg-icon
            [iconType]="'social'"
            [color]="compromiso.dimensionS ? 'currentColor' : '#cfcfcf'"
            matTooltip="Social"
          ></app-svg-icon>
          <app-svg-icon
            [iconType]="'gobernanza'"
            [color]="compromiso.dimensionG ? 'currentColor' : '#cfcfcf'"
            matTooltip="Gobernanza"
          ></app-svg-icon>
        </div>
      </li>
    </ul>
  </ul>
</div>
